<template>
  <z-dialog
    :show="isVisible"
    :modalSize="modalSize"
    :dStyle="dStyle"
    :bdStyle="bdStyle"
  >
    <template v-slot:header>
      <div class="row custom-header">
        <div class="col-md-6">
          <h4 class="modal-title">
            {{ title }}
          </h4>
        </div>
        <div class="col-md-5">
          <z-message
            v-model="message"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
        <div class="col-md-1 custom-close">
          <button
            type="button"
            class="btn-close"
            @click="close(false)"
          ></button>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-12">
          <p>Use the following to manage challenges.</p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <span>challenge info here</span>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': highlightSave }"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': highlightSave }"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="close(false)"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm-delete
    :show="actionDelete"
    :confirmTitle="confirmTitle"
    :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZStepper from '@/Components/ZElements/Stepper'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'challenge-dialog',
  components: {
    ZDialog,
    ZStepper,
    ZTable,
    ZSelect,
    ConfirmDelete,
    ZMessage,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
    dStyle: String,
    bdStyle: String,
  },
  data() {
    return {
      modalSize: 'modal-lg',
      list: null,
      listName: '',
      newListName: '',
      confirmTitle: 'Remove Challenge',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this challenge',
      actionDelete: null,
      highlightSave: false,
      message: '',
    }
  },
  emits: ['close', 'saved'],
  computed: {
    ...mapGetters('usercardio', ['lists', 'clients']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        _title = this.show.title
      }
      return _title
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'setList',
      'saveList',
      'resetLists',
      'removeList',
    ]),
    confirmRemoval() {
      this.actionDelete = true
    },
    async performDeletion() {
      this.actionDelete = null
      // Make Call to Server to Remove Challenge
      let result = await this.removeList(this.list.id)
      if (result.errors.length === 0) {
        let data = {
          name: 'remove',
          value: this.list.id,
        }
        this.setList(data)
        this.reset()
      } else {
        alert('Error: ' + result.data)
      }
    },
    closeModal() {
      this.actionDelete = null
    },
    close(isSaved) {
      if (isSaved) {
        this.$emit('saved')
      } else {
        this.$emit('close')
      }
    },
    async performSave(closeIt) {
      this.highlightSave = false
      // Make Call to Server to Save List
      let ids = []
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  position: absolute;
  right: -10px;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.form-select:focus {
  outline: none !important;
  box-shadow: none !important;
}
.custom-list {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-arrow-buttons-wrapper {
  padding: 0;
}
.custom-arrow-buttons {
  width: 30px;
  text-align: center;
  button {
    font-size: 1.2em;
  }
}
.custom-list-name {
  min-width: 100px;
}
.custom-list-wrapper {
  min-height: 350px;
}
</style>
